<template>
  <el-table-column
    prop="extra_fields"
    label="Egyéb adatok"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <div v-for="(item, key, index) in scope.row.extra_fields">
        {{ key }}: {{ item }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'extra_fields',
  };
</script>
